export const usuariosListId = 'abac0f22bc';

export const teacherTags = {
  newRockalingua: 'newRockalingua',
  noSubscription: 'noSubscription',
  trial: 'trial',
  community: 'community',
  communityWaitingList: 'community-waiting-list',
  unused: 'unused',
  loginAfterTrialExpired: 'loginAfterTrialExpired',
  inactive: 'inactive',
  segmentA: 'segment-a',
  segmentB: 'segment-b',
};
